export class ProductDeliveryDTO {
  sku:any;
  deliveryOpt: any;
  station: any;
  deliveryCharges: any;
  deliveryDesc: any;
  vehicleType:any;
  paymentMethod:any;
}
